/**
 * Форматирует телефон
 * +79168081180 => +7 916 808-11-80
 */
export function getFormattedPhone(phone: string) {
  const countryCode = phone.substr(0, 2);
  const rawPhoneNumber = phone.substr(2);
  const phoneNumberFormatted = rawPhoneNumber.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2-$3-$4');

  return `${countryCode} ${phoneNumberFormatted}`;
}
